import { useEffect, useState } from "react";

import Dropdown from "./doctype-dropdown";
import UploadBox from "./upload-box";

import "./file-upload.css";
import { Box, Typography, useMediaQuery } from "@mui/material";
import axios from "axios";
import { useLocation } from "react-router-dom";
import { signOut } from "firebase/auth";

import { UseSnackbar } from "../snackbar/snackbarContext";
import Greenbanner from "../header/greenbanner";
import { auth } from "../../auth/firebase-config";

import Loader from "./loader";
import Stepper from "./stepper";
import ProductDropdown from "./product-dropdown";

export default function EditUpload() {
  const showSnackbar = UseSnackbar();
  const location = useLocation();
  const edit_data = location.state.edit_value;
  const [conversation_id, setConversation_id] = useState(
    edit_data.conversation_id
  );
  const [source_ids, setsource_ids] = useState([]);
  const [document_data, setdocument_data] = useState([]);
  const [docType, setdocType] = useState("");
  const [loading, setload] = useState(true);
  const storedUserInfo = JSON.parse(localStorage.getItem("userInfo"));
  const accessToken = localStorage.getItem("accessToken");
  const [editUpload, seteditUpload] = useState(true);
  const [selectedFile, setSelectedFile] = useState([]);
  const [products, setProducts] = useState([]);
  const [savedProducts, setSavedProducts] = useState([]);

  const matches = useMediaQuery("(max-width:1150px)");

  const doctypes = {
    "Feature needs with Rationale": "Generate Feature Needs with Rationale",
    "Feature Needs with Rationale": "Generate Feature Needs with Rationale",
    "Use cases": "Generate Use cases",
    "Feature Requirements with Rationale":
      "Generate Feature Requirements with Rationale",
    "User Stories": "Generate User Stories",
    "Test Case Steps": "Generate Test Case Steps",
    "Acceptance Criteria & Expected Results":
      "Generate Acceptance Criteria & Expected Results",
    "System Requirements": "Generate Parent",
    "End to End Traceability": "End to End Traceability",
  };
  const is_editable = edit_data.is_editable;
  useEffect(() => {
    setdocType(doctypes[edit_data.doctype]);
    get_source_id();
  }, []);

  useEffect(() => {
    const fetchSourceData = async () => {
      try {
        const requests = source_ids.map((id) =>
          axios.get(`${import.meta.env.VITE_API_URL}/Source/${id}`, {
            headers: {
              Authorization: `Bearer ${accessToken}`,
              "Content-Type": "application/json",
            },
          })
        );

        const responses = await Promise.all(requests);
        const data = responses.reduce((acc, response) => {
          const { source_type, doc_url, id } = response.data.data;

          if (source_type === "additional_files") {
            if (!acc[source_type]) {
              acc[source_type] = [];
            }
            acc[source_type].push({ id, doc_url, source_generated: true });
          } else {
            acc[source_type] = { id, doc_url, source_generated: true };
          }

          return acc;
        }, {});
        setdocument_data(data);
      } catch (error) {
        if (error.response && error.response.status === 401) {
          signOut(auth)
            .then(() => {
              localStorage.removeItem("userInfo");
              localStorage.removeItem("accessToken");
              localStorage.removeItem("user_data");
              console.log("User signed out due to inactivity.");
            })
            .catch((signOutError) => {
              console.error("Error signing out:", signOutError);
            });
        } else {
          showSnackbar("Something Went Wrong! Please Refresh! ", "error");
          throw new Error(`Internal server error: ${error}`);
        }
        setload(false);
      } finally {
        setload(false);
      }
    };

    if (source_ids.length > 0) {
      fetchSourceData();
    }
  }, [source_ids, accessToken]);

  const get_source_id = async () => {
    const accessToken = localStorage.getItem("accessToken");

    const API_URL = `${
      import.meta.env.VITE_API_URL
    }/conversation/${conversation_id}`;

    try {
      const response = await axios.get(API_URL, {
        headers: {
          Authorization: `Bearer ${accessToken}`,
          "Content-Type": "application/json",
        },
      });

      setsource_ids(response.data?.data?.source_Ids);
      setProducts(response.data?.data?.product_field);
      setSavedProducts(response.data?.data?.product_field);
      return response;
    } catch (error: any) {
      if (error.response && error.response.status === 401) {
        signOut(auth)
          .then(() => {
            localStorage.removeItem("userInfo");
            localStorage.removeItem("accessToken");
            localStorage.removeItem("user_data");
            console.log("User signed out due to inactivity.");
          })
          .catch((signOutError) => {
            console.error("Error signing out:", signOutError);
          });
      } else {
        showSnackbar("Something Went Wrong! Please Refresh! ", "error");
        throw new Error(`Internal server error: ${error}`);
      }
    }
  };

  return (
    <Box>
      <Greenbanner name={`Welcome ${storedUserInfo.name}`} />
      {loading && <Loader textrecieved="Processing Uploaded Files..." />}
      <Box sx={{ ml: 2, mr: 2, mt: 2 }}>
        <Box className="top-upload">
          <Box className="starter">
            <Typography
              variant="h6"
              sx={{ fontWeight: "bolder", fontSize: "18px" }}
            >
              Get Started here...
            </Typography>
            <Typography
              variant="h6"
              sx={{ mt: 0.5, fontSize: "16px", fontWeight: "bold" }}
            >
              Choose a type of document you would like to generate:
            </Typography>

            <Box
              sx={{
                display: "flex",
                flexDirection: matches ? "column" : "row",
                width: "100%",
              }}
            >
              <Box sx={{ mt: 0.5, mb: 2, marginRight: "1rem" }}>
                <Dropdown doctype={docType} disabled />
              </Box>

              {docType !== "End to End Traceability" &&
                docType !== "Generate User Stories" &&
                docType !== "Generate Test Case Steps" &&
                docType !==
                  "Generate Acceptance Criteria & Expected Results" && (
                  <Box sx={{ mt: 0.5, mb: 2 }}>
                    <ProductDropdown
                      products={products || []}
                      setProducts={setProducts}
                      isDisabled={false}
                    />
                  </Box>
                )}
            </Box>
          </Box>
          <Box className="tree-box">
            <Stepper doctype={docType} />
          </Box>
        </Box>
        {docType && docType.trim() !== "" ? (
          <Box className="UploadBox">
            <Typography
              variant="h6"
              sx={{
                fontWeight: "bold",
                fontSize: "16px",
                color: "#0085CA",
                fontStyle: "italic",
                mb: 1,
              }}
            >
              Note: Upload all mandatory documents here(.pdf,.txt,.doc):
            </Typography>
            <UploadBox
              docType={docType}
              products={products}
              savedProducts={savedProducts}
              loading={loading}
              setload={setload}
              seteditUpload={seteditUpload}
              editUpload={editUpload}
              document_data={document_data}
              conversation_id={conversation_id}
              document_id={edit_data.document_id}
              document_project_type={edit_data.project_type}
              setdocument_data={setdocument_data}
              userdisabled={!is_editable}
            />
          </Box>
        ) : null}
      </Box>
    </Box>
  );
}
